import { render } from "./CdLanLogo.vue?vue&type=template&id=19f4d34a"
import script from "./CdLanLogo.vue?vue&type=script&lang=js"
export * from "./CdLanLogo.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__